import { BaseFetch } from "../main-model"
export default class ReportCurriculumModel extends BaseFetch {
    getReportCurriculumBy = (data) =>
    this.authFetch({
      url: "report-curriculum/getReportCurriculumBy",
      method: "POST",
      body: JSON.stringify(data),
    })

    getReportCurriculumAllBy = (data) =>
    this.authFetch({
      url: "report-curriculum/getReportCurriculumAllBy",
      method: "POST",
      body: JSON.stringify(data),
    })
}
